module.exports = __webpack_public_path__ + "static/img/pz.b669620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/pz.jpg
// module id = ou7H
// module chunks = 7